module.exports = __webpack_public_path__ + "static/media/amex-icon.07f9fde7.svg";